import React, { useCallback, useEffect, useState } from 'react'
import { useRoute, useRouter } from 'react-router5'
import { Button } from '@material-ui/core'
import Device from './device-frames/device';
import MainScreen from './MainScreen'
import Leaderboard from './Leaderboard'
import Quiz, { generateQuiz } from './Quiz'
import QuizPicker from './QuizPicker'
import QuizSubmission from './QuizSubmission'
import Settings from './Settings'
import { ThemeProvider } from '@material-ui/core';
import { createMuiTheme } from '@material-ui/core/styles';
import { getSeedsFor } from '../seeds'
import { shouldEnableTimer, shouldRandomizeQuestions } from './Settings'

const theme = createMuiTheme({
  typography: {
    fontFamily: 'Titillium Web',
    fontSize: 16
  }
});

const quizSubmissions = [].concat(getSeedsFor('quiz_submission'))
const quizzes = []

const Screen = () => {
  const { route } = useRoute()
  const router = useRouter()
  const [quiz, setQuiz] = useState(null)

  useEffect(() => {
    if (route.name === 'quiz' || (route.name === 'quiz_question' && !quiz)) {
      setQuiz({
        id: route.params.unit,
        ...generateQuiz({
          unit: route.params.unit,
          shufflePoolSize: 10,
          shuffle: shouldRandomizeQuestions()
        })
      })
    }
    else if (route.name === 'quiz_question') {
    }
    else {
      setQuiz(null)
    }
  }, [ route.name, route.params.unit ])

  const submitQuiz = useCallback(submission => {
    quizSubmissions.push(submission)

    quizzes.push({ id: quiz.id })

    router.navigate('quiz_submission', { id: quiz.id })
  }, [ quiz, router ])

  if (!route) {
    return null
  }

  const nextQuizId = parseInt((quizzes[quizzes.length-1] || { id: '0' }).id, 10) + 1

  if (route.name === 'home') {
    return (
      <MainScreen
        nextQuizId={nextQuizId}
      />
    )
  }

  if (route.name === 'leaderboards') {
    return (
      <QuizPicker onChooseModule={module => router.navigate('leaderboard', { id: module })} />
    )
  }

  if (route.name === 'leaderboard') {
    return (
      <Leaderboard unit={route.params.id} />
    )
  }

  if (route.name === 'settings') {
    return (
      <Settings unit={route.params.id} />
    )
  }

  if (route.name === 'quiz_picker') {
    return (
      <QuizPicker onChooseModule={unit => router.navigate('quiz', { unit })} />
    )
  }

  if (route.name === 'quiz') {
    return (
      <Quiz
        id={route.params.id}
        quiz={quiz}
        questionIndex={0}
        onSubmit={submitQuiz}
      />
    )
  }

  if (route.name === 'quiz_question') {
    return (
      <Quiz
        quiz={quiz}
        questionIndex={parseInt(route.params.question, 10)}
        onSubmit={submitQuiz}
      />
    )
  }

  if (route.name === 'quiz_submission') {
    const submission = quizSubmissions.find(x => x.quizId === route.params.id)

    if (!submission) {
      return <Redirect to="home" />
    }

    return (
      <QuizSubmission
        {...submission}
      />
    )
  }
}

const Redirect = ({ to }) => {
  const router = useRouter()

  useEffect(() => {
    router.navigate(to)
  }, [router, to])

  return null
}

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <Device use="galaxy-s5" color="black">
        <Screen />
      </Device>
    </ThemeProvider>
  )
}